<template>
  <div class="home">
    <HelloWorld msg="Welcome to Cola's Private Trading System" />
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    HelloWorld,
  },
};
</script>
